import React, { useState, useCallback, useEffect, useRef, ReactElement } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { ContainerWIthTopBottomMargin, EqualColumnFlexContainer, ProductContainerColumn, ProductFeature, ProductTitle, SelectedColumn } from "./common/Containers";
import { FooterNavigationButtons } from "./common/FooterNavigationButtons";
import { commonUXTheme } from "styles/commonUXVariables";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Carousel, CarouselItem } from "framework/components/Carousel";
import { Heading } from "@abb/abb-common-ux-react";

const ComparisonStep = (): JSX.Element => {
    const { t } = useTranslation();
    const itemWidth = 200;

    return <Box width={"100%"}>
        <Box textAlign={"center"} mt={commonUXTheme.sizes.m} mb={commonUXTheme.sizes.m} >
            <Heading text={t("Comparison")} showCursor={false} level={3}></Heading>
        </Box>
        <Grid container gap={1}>
            <Grid item flexGrow={1} xs minWidth={itemWidth} >
                <Carousel >
                    <CarouselItem>
                        <SelectedColumn>
                            <ProductTitle container alignItems={"center"}>Test Lorem isi o dfndj Fakkst eeaf fsdjk ehuer.</ProductTitle>
                            <ProductFeature $lite={true} container alignItems={"center"}>Test</ProductFeature>
                            <ProductFeature container alignItems={"center"}>Test</ProductFeature>
                            <ProductFeature $lite={true} container alignItems={"center"}>Test</ProductFeature>
                            <ProductFeature container alignItems={"center"}>Test</ProductFeature>
                        </SelectedColumn>
                    </CarouselItem>
                    <CarouselItem>
                        <ProductContainerColumn>
                            <ProductTitle container alignItems={"center"}>Test Lorem isi o dfndj Fakkst eeaf fsdjk ehuer.</ProductTitle>
                            <ProductFeature $lite={true} container alignItems={"center"}>Test</ProductFeature>
                            <ProductFeature container alignItems={"center"}>Test</ProductFeature>
                            <ProductFeature $lite={true} container alignItems={"center"}>Test</ProductFeature>
                            <ProductFeature container alignItems={"center"}>Test</ProductFeature>
                        </ProductContainerColumn>
                    </CarouselItem>
                    <CarouselItem>
                        <ProductContainerColumn>test</ProductContainerColumn>
                    </CarouselItem>
                </Carousel>
            </Grid>
        </Grid>
    </Box>
}

export default ComparisonStep;
